<template>
  <div class="site-footer">
    <div class="mainBox">
      <div class="bg-img-box">
        <img src="https://huachuangev.com/picFile/logo2.png?0" alt="华锋新能源" />
        <img src="@/assets/image/logo11.png" alt="北京理工华创" class="logo"/>
        <!-- <img src="https://huachuangev.com/picFile/hclogo.d1520146.png" alt="北京理工华创" class="logo"/> -->
        <!-- <img src="@/assets/image/logo2.png" alt="华锋新能源" />
        <img src="@/assets/image/logo.png" alt="北京理工华创" class="logo"/> -->
      </div>
      <div class="cont">
        <div class="box1-intro">
          <div class="list-box">
            <el-skeleton :loading="loading" animated>
              <template slot="template">
                <el-skeleton-item variant="p" style="width: 10%;" />
                <el-skeleton-item variant="p" style="width: 25%;" />
                <el-skeleton-item variant="p" style="width: 15%;" />
                <el-skeleton-item variant="p" style="width: 30%;" />
              </template>
              <template>
                <p>股票代码：002806</p>
                <p>地址：{{ contact.addr }}</p>
                <p>电话：{{ contact.tel }}</p>
                <p>邮箱：{{ contact.email }}</p>
              </template>
            </el-skeleton>
          </div>
        </div>
        <div class="box2">
          <h3>友情链接</h3>
          <p><a href="http://www.hfne.com.cn/" target="_blank">华锋新能源</a></p>
          <p><a href="https://www.d1ev.com/" target="_blank">第一电动网</a></p>
          <p><a href="https://www.bit.edu.cn/" target="_blank">北京理工大学</a></p>
        </div>
      </div>
    </div>
    <div class="box4">
      <p>网站声明：本网站及个人肖像的照片，严禁转载，违者追究相关法律责任</p>
      <div class="site-line"></div>
      <div class="site-box">
        <!-- <div class="box2"> -->
          <a href="https://beian.miit.gov.cn" target="_blank">京ICP备11027011号-1</a>
          <!-- <img src="@/assets/image/gongan.jpg" alt="" />
          <p>晋公网安备XXXXXX号</p> -->
        <!-- </div> -->
        <p>Copyright © 2023 北京理工华创</p>
      </div>
    </div>
  </div>
</template>

<script>
import News from '@/api/api.js'
export default {
  data() {
    return {
      loading: true,
      contact: '',
    }
  },
  created() {
    this.getContactInfo()
  },
  mounted() {
  },
  methods: {
    async getContactInfo(){
      let res = await News.getUser();
      // console.log('获取地址栏信息-------',res)
      if (res.code===0){
        this.contact = res.msg;
        this.loading = false
      } else {
        this.$message.error("获取联系方式失败")
      }
    }
  }
};
</script>

<style lang="scss"  scoped >
/deep/ .el-skeleton__p {
    display: block;
    height: 16px;
    margin: 11px 0;
}
.site-footer {
  position: relative;
  // width: 100%;
  // width: var(--fixed-width);
  // height: 300px;
  background: #222;
  padding: 20px 0;
  .mainBox {
    width: var(--base-width);
    margin: 0 auto;
    padding-top: 40px;
    color: #fff;
    line-height: 30px;
    .bg-img-box {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        img {
          height: 40px;
        }
        .logo {
          // width: 40px;
          height: 45px;
          margin-left: 4px;
        }
        .site-title {
          font-size: 16px;
          color: hsla(0, 0%, 100%, 0.5);
          margin-left: 10px;
          &:hover {
            color: rgb(44, 65, 180);
            cursor: pointer;
          }
        }
      }
    .cont {
      display: flex;
      justify-content: space-between;
      .box1-intro {
        width: 70%;
      }
      .box2 {
        width: 30%;
        text-align: right;
        h3 {
          margin: 0px;
        }
        a {
          color: #fff;
          line-height: 30px;
        }
      }
    }

    .box3 {
      display: flex;
      align-items: center;
      img {
        width: 120px;
        height: 120px;
        &:nth-child(2) {
          margin-left: 15px;
        }
      }
    }
  }
  .box4 {
    width: var(--base-width);
    margin: 0 auto;
    font-size: 14px;
    line-height: 30px;
    color: #fff;
    .site-line {
      width: 100%;
      margin: 10px auto 0;
      height: 2px;
      background: #393939;
    }
    .site-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      color: #999;
      position: relative;
      a {
        display: block;
        width: 100%;
        color: #999;
        cursor: pointer;
        position: absolute;
        top: 10px;
        text-align: center;
        @media only screen and (min-width: 300px) and (max-width: 768px) {
          position: static;
        }
        // p {
        //   margin-top: 10px 0;
        // }
        // img {
        //   width: 15px;
        //   height: 15px;
        // }
      }
      P {
        margin-top: 10px;
        width: 100%;
        text-align: right;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/layout/Footer.vue